import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import ReactHtmlParser from 'react-html-parser';

const relatedItems = require('../../model/related.json');

const Related = props => {

    let rel = relatedItems;
    for (let i = 0; i < props.section.length; i++)
    {
        rel = rel[props.section[i]];
    }

    const [items, setItems] = useState(rel);

    const indicatorIcons = (pItem) => {
        return pItem.icon+'-icon';
    }

    const trimText = (pText) => {
        const replacedText = pText.slice(/<\/*[a-z][a-z0-9]*[^<>]*>|<!--.*?-->/img);

        if (replacedText.length > 80) {
            if (pText.match(/<[^>]+>/)) {
                return (`${pText.substring(0, 80).split(" ").slice(0, -1).join(" ")}<span class='dots'>...</span>`);
            } else {
                return (`<p class="text-related-item">${pText.substring(0, 80).split(" ").slice(0, -1).join(" ")}<span class='dots'>...</span></p>`);
            }
        }
        return (`<p class="text-related-item">${pText}</p>`);
    }

    const buildLink = (link, params) => {
        if (params != undefined)
        {
            let linkText = link;
            for (let i = 0; i < params.length; i++)
            {
                if (props[params[i]] != undefined)
                {
                    linkText = linkText+'/'+props[params[i]];
                }
            }
            return linkText;
        }
        return link;
    }

    useEffect(() => {
        let rel = relatedItems;
        for (let i = 0; i < props.section.length; i++) {
            rel = rel[props.section[i]];
        }
        setItems(rel);
    }, props.section)

    if (items != undefined && items.length > 0)
    {
        return(
            <section className="container-full section--page section--related--content">
                <div className="container related--content--wrapper">
                    <h2 className="title-related-content">{ props.literals.L20712 }</h2>
                    <div className="related-content-items">
                        {/* RELATED ITEMS */ }
                        { items.map((item, index) => 
                            <div key={`tab-${index}`} className="related-content-item">
                                <div className={"icon-related-item hide-mobile "+ indicatorIcons(item)}></div>
                                <div className="content-related-item">
                                    <h3 className="title-related-item">{ props.literals[ item.title ] }</h3>
                                    { ReactHtmlParser(trimText( props.literals[ item.text ] )) }
                                    <p className="button-related-item btn--block-full left-text">
                                        <Link className="btn-default btn-main-color" to={ buildLink(item.link, item.linkParams) }>{ props.literals.L480 }</Link>
                                    </p>
                                </div>
                            </div>
                        ) }
                    </div>
                </div>
            </section>
        )
    }
    else
    {
        return null;
    }
}

export default Related;